// Analytics tracking utility
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const trackEvent = async (eventType, data = {}) => {
  try {
    const token = localStorage.getItem('fx_token');
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    await fetch(`${API_URL}/api/analytics/track`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        event_type: eventType,
        page: window.location.pathname,
        referrer: document.referrer,
        ...data
      })
    });
  } catch (error) {
    // Silently fail - analytics shouldn't break the app
    console.debug('Analytics tracking failed:', error);
  }
};

// Convenience methods
export const trackPageView = (page) => trackEvent('page_view', { page: page || window.location.pathname });
export const trackBrokerView = (brokerId) => trackEvent('broker_view', { broker_id: brokerId });
export const trackButtonClick = (elementId, elementText) => trackEvent('button_click', { element_id: elementId, element_text: elementText });
export const trackSearch = (query) => trackEvent('search', { search_query: query });

// VPS Affiliate Link Tracking
export const trackVPSClick = (source) => trackEvent('vps_affiliate_click', { 
  source: source,
  affiliate_link: 'https://secure.fxsvps.com/aff.php?aff=597'
});

// Review submission tracking
export const trackReviewSubmit = (brokerId, rating) => trackEvent('review_submit', { 
  broker_id: brokerId,
  rating: rating 
});

export default {
  trackEvent,
  trackPageView,
  trackBrokerView,
  trackButtonClick,
  trackSearch,
  trackVPSClick,
  trackReviewSubmit
};
